
import { v2Host } from '@/config/host';
import { getToken } from '@/utils/auth';
import { reduceFileAccept } from '@/common/file';
import { getApiPath } from '@/common/api-proxy.js';

export default {
  props: {
    acceptType: {
      type: Array
    }
  },

  data: function data() {
    return {
      action: '' + v2Host + getApiPath('/upload/file')
    };
  },


  computed: {
    accept: function accept() {
      if (this.acceptType) return reduceFileAccept(this.acceptType);
      return this.$attrs.accept;
    }
  },

  methods: {
    getHeaders: function getHeaders() {
      return {
        'Auth-Token': getToken()
      };
    },
    clearFiles: function clearFiles() {
      return this.$refs.uploader.clearFiles();
    },
    abort: function abort() {
      return this.$refs.uploader.abort();
    }
  }
};